import agentsFormModel from './agentsFormModel';

const {
    formField: {
        name,
        description,
        service_id,
        systemPrompt,
        temperature,
        topP,
        maxTokens,
        enableTools,
        enableMemory,
        enableReasoning,
        enableFunctionCall,
        enableSearch,
        enableCodeExecution,
        executionMode
    }
} = agentsFormModel;

export default {
    [name.name]: '',
    [description.name]: '',
    [service_id.name]: undefined,
    [systemPrompt.name]: '',
    [temperature.name]: '',
    [topP.name]: '',
    [maxTokens.name]: '',
    [enableTools.name]: false,
    [enableMemory.name]: false,
    [enableReasoning.name]: false,
    [enableFunctionCall.name]: false,
    [enableSearch.name]: false,
    [enableCodeExecution.name]: false,
    [executionMode.name]: 'AUTO'
};
